//Reset data
export const RESET = "POINT_FOCAL_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "POINT_FOCAL_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "POINT_FOCAL_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "POINT_FOCAL_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "POINT_FOCAL_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "POINT_FOCAL_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "POINT_FOCAL_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "POINT_FOCAL_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "POINT_FOCAL_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "POINT_FOCAL_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "POINT_FOCAL_CREATE_SET_CREATED"
export const SET_IS_CREATED = "POINT_FOCAL_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "POINT_FOCAL_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "POINT_FOCAL_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "POINT_FOCAL_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "POINT_FOCAL_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "POINT_FOCAL_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "POINT_FOCAL_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "POINT_FOCAL_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "POINT_FOCAL_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "POINT_FOCAL_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "POINT_FOCAL_CREATE_SET_MODAL_TYPE"